export default {
  props: {
    data: {
      type: Object,
    },
  },
}
